import {merge, omit, set, unset, remove, cloneDeep, get, has, split, slice} from 'lodash';

export function operationReducer(prevState, action) {
    switch (action.type) {
        case 'init':
            if (action.op) {
                return cloneDeep(action.op);
            } else {
                return null;
            }
        case 'merge-op-fields':
            return {...prevState, ...action.fields};
        case 'add-op-block':
            prevState[action.block.key] = action.block.value;
            break;
        case 'rm-op-block':
            console.log('remove block', prevState, action.block);
            unset(prevState, action.block.key);
            break;
        case 'add-op-parameter':
            console.log('add operation parameter', action);
            prevState.parameters = prevState.parameters || [];
            action.param.map((param) => {
                if (param.$ref) {
                    const newParam = {
                        $ref: param.$ref,
                    };
                    prevState.parameters.push(newParam);
                } else {
                    const newParam = {
                        name: param.name,
                        schema: {
                            type: param.type || 'string',
                        },
                        in: param.in || 'path',
                    };
                    prevState.parameters.push(newParam);
                }
            });
            break;
        case 'rm-op-parameter':
            remove(prevState.parameters, (p) => {
                if (p.$ref) {
                    return p.$ref === action.$ref;
                } else {
                    return p.name === action.name;
                }
            });
            break;
        case 'param-rename':
            const target = remove(prevState.parameters, (p) => p.name === action.from);
            if (target.length > 0) {
                target[0].name = action.to;
                prevState.parameters.push(target[0]);
            }
            break;
        case 'update-param':
            console.log('updating parameter', action);
            const param = prevState.parameters.find((p) => p.name === action.name);
            if (param) {
                merge(param, action.fields);
            }
            break;
        case 'add-body-content-type':
            prevState.requestBody.content = prevState.requestBody.content || {};
            prevState.requestBody.content[action.contentType] = action.value;
            break;
        case 'update-body-content-schema':
            switch (action.changeSet.op) {
                case 'remove':
                    unset(prevState.requestBody, action.changeSet.propName);
                    break;
                case 'move':
                    const renamedField = get(prevState.requestBody, action.changeSet.key) || {};
                    renamedField.name = action.changeSet.name;
                    set(prevState.requestBody, action.changeSet.propName, renamedField);
                    unset(prevState.requestBody, action.changeSet.key);
                    break;
                case 'set-required':
                    if (action.changeSet.required) {
                        set(prevState.requestBody, action.changeSet.propName, get(prevState.requestBody, action.changeSet.propName) || []);
                        get(prevState.requestBody, action.changeSet.propName).push(action.changeSet.key);
                    } else {
                        remove(get(prevState.requestBody, action.changeSet.propName), (key) => key === action.changeSet.key);
                    }
                    set(prevState.requestBody, action.changeSet.propName, get(prevState.requestBody, action.changeSet.propName) || []);
                    break;
                case 'add':
                    if (action.changeSet.$ref) {
                        set(prevState.requestBody, action.changeSet.propName, omit(action.changeSet, 'propName', 'key', 'op', 'type', 'name'));
                    } else {
                        action.changeSet.fields.forEach((field) => {
                            set(prevState.requestBody, field.propName, omit(field, 'key', 'propName', 'op', 'name'));
                        });
                    }
                    break;
                case 'change-schema-type':
                    let changedSchema = prevState;
                    if (action.changeSet.schemaPath) {
                        changedSchema = get(prevState.requestBody, action.changeSet.schemaPath);
                        if (!changedSchema) {
                            let mimeTypeArray = split(action.changeSet.schemaPath, '.');
                            mimeTypeArray = slice(mimeTypeArray, 2, mimeTypeArray.length - 1);
                            let mimeType = mimeTypeArray.join('.');
                            let pathArray = split(action.changeSet.schemaPath, '.', 2);
                            pathArray.push(mimeType);
                            pathArray.push('schema');
                            changedSchema = get(prevState.requestBody, pathArray);
                        }
                    }
                    if (['allOf', 'oneOf', 'anyOf'].indexOf(action.changeSet.targetType) !== -1) {
                        changedSchema[action.changeSet.targetType] = [];
                        unset(changedSchema, 'items');
                        unset(changedSchema, 'type');
                        unset(changedSchema, 'properties');
                    } else {
                        if (get(changedSchema, 'items.properties') || get(changedSchema, 'properties')) {
                            if (changedSchema.type === 'array') {
                                changedSchema.type = action.changeSet.targetType;
                                changedSchema.properties = get(changedSchema, 'items.properties') || get(changedSchema, 'properties');
                                unset(changedSchema, 'items');
                            } else {
                                changedSchema.type = action.changeSet.targetType;
                                changedSchema.items = {properties: get(changedSchema, 'properties') || get(changedSchema, 'items.properties')};
                                unset(changedSchema, 'properties');
                            }
                        } else {
                            if (has(changedSchema, 'items')) {
                                unset(changedSchema, 'items');
                            } else {
                                unset(changedSchema, 'properties');
                            }
                            changedSchema.type = 'object';
                            changedSchema.properties = {};
                        }
                    }
                    break;
                case 'add-schema-ref': {
                    let changedSchema = prevState;
                    if (action.changeSet.schemaPath) {
                        changedSchema = get(prevState.requestBody, action.changeSet.schemaPath);
                    }
                    changedSchema[action.changeSet.operator].push({$ref: action.changeSet.link});
                    break;
                }
                case 'rm-schema-ref': {
                    let changedSchema = prevState;
                    if (action.changeSet.schemaPath) {
                        changedSchema = get(prevState.requestBody, action.changeSet.schemaPath);
                    }
                    if (action.changeSet.link) {
                        remove(changedSchema[action.changeSet.operator], (remoteSchema) => remoteSchema.$ref === action.changeSet.link);
                    } else {
                        changedSchema[action.changeSet.operator].splice(action.changeSet.key, 1);
                    }
                    break;
                }
                case 'set-schema-ref': {
                    let changedSchema = prevState;
                    if (action.changeSet.schemaPath) {
                        changedSchema = get(prevState.requestBody, action.changeSet.schemaPath);
                    }
                    changedSchema.type = action.changeSet.type;
                    if (action.changeSet.type === 'array') {
                        changedSchema.items = {$ref: action.changeSet.link};
                    } else {
                        changedSchema.$ref = action.changeSet.link;
                    }
                    break;
                }
                case 'change-combine-operator': {
                    let changedSchema = prevState;
                    if (action.changeSet.schemaPath) {
                        changedSchema = get(prevState.requestBody, action.changeSet.schemaPath);
                    }
                    set(changedSchema, action.changeSet.operator, get(changedSchema, action.changeSet.old));
                    unset(changedSchema, action.changeSet.old);
                    break;
                }
                case 'add-inline-schema': {
                    let changedSchema = prevState;
                    if (action.changeSet.schemaPath) {
                        changedSchema = get(prevState.requestBody, action.changeSet.schemaPath);
                    }
                    changedSchema[action.changeSet.operator].push(action.changeSet.schema);
                    break;
                }
                case 'toggle-additional-properties': {
                    let changedSchema = prevState;
                    if (action.changeSet.schemaPath) {
                        changedSchema = get(prevState.requestBody, action.changeSet.schemaPath);
                    }
                    changedSchema.additionalProperties = action.changeSet.additionalProperties;
                    break;
                }
                default:
                    const value = get(prevState.requestBody, action.changeSet.propName) || {};
                    set(prevState.requestBody, action.changeSet.propName, merge(value, omit(action.changeSet, 'propName', 'op')));
                    break;
            }
            break;
        case 'rm-body-content-type':
            unset(prevState.requestBody.content, action.contentType);
            break;
        case 'rm-request-body':
            unset(prevState, 'requestBody');
            break;
        case 'add-response-content-type':
            prevState.responses[action.code || 'default'].content = prevState.responses[action.code || 'default'].content || {};
            prevState.responses[action.code || 'default'].content[action.contentType] = action.value;
            break;
        case 'rm-response-content-type':
            unset(prevState.responses[action.code || 'default'].content, action.contentType);
            break;
        case 'change-response-code':
            const old = get(prevState.responses, action.from);
            prevState.responses[action.to] = old;
            unset(prevState.responses, action.from);
            break;
        case 'update-response-code':
            merge(prevState.responses[action.code], action.value);
            break;
        case 'add-response-code':
            const content = {};
            content[action.contentType] = {schema: {properties: {}, type: 'object'}};
            merge((prevState.responses[action.code] = {content}));
            break;
        case 'update-response-content-schema':
            switch (action.changeSet.op) {
                case 'remove':
                    unset(prevState.responses, action.changeSet.propName);
                    break;
                case 'move':
                    const renamedField = get(prevState.responses, action.changeSet.key) || {};
                    renamedField.name = action.changeSet.name;
                    set(prevState.responses, action.changeSet.propName, renamedField);
                    unset(prevState.responses, action.changeSet.key);
                    break;
                case 'set-required':
                    if (action.changeSet.required) {
                        set(prevState.responses, action.changeSet.propName, get(prevState.responses, action.changeSet.propName) || []);
                        get(prevState.responses, action.changeSet.propName).push(action.changeSet.key);
                    } else {
                        remove(get(prevState.responses, action.changeSet.propName), (key) => key === action.changeSet.key);
                    }
                    set(prevState.responses, action.changeSet.propName, get(prevState.responses, action.changeSet.propName) || []);
                    break;
                case 'add':
                    if (action.changeSet.$ref) {
                        set(prevState.responses, action.changeSet.propName, omit(action.changeSet, 'key', 'propName', 'op', 'type', 'name'));
                    } else {
                        action.changeSet.fields.forEach((field) => {
                            set(prevState.responses, field.propName, omit(field, 'key', 'propName', 'op', 'name'));
                        });
                    }
                    break;
                case 'change-schema-type':
                    console.log('changing schema type', action.changeSet.schemaPath);
                    let changedSchema = prevState;
                    if (action.changeSet.schemaPath) {
                        changedSchema = get(prevState.responses, action.changeSet.schemaPath);
                        if (!changedSchema) {
                            let mimeTypeArray = split(action.changeSet.schemaPath, '.');
                            mimeTypeArray = slice(mimeTypeArray, 2, mimeTypeArray.length - 1);
                            let mimeType = mimeTypeArray.join('.');
                            let pathArray = split(action.changeSet.schemaPath, '.', 2);
                            pathArray.push(mimeType);
                            pathArray.push('schema');
                            changedSchema = get(prevState.responses, pathArray);
                        }
                    }
                    if (['allOf', 'oneOf', 'anyOf'].indexOf(action.changeSet.targetType) !== -1) {
                        changedSchema[action.changeSet.targetType] = [];
                        unset(changedSchema, 'items');
                        unset(changedSchema, 'type');
                        unset(changedSchema, 'properties');
                    } else {
                        if (get(changedSchema, 'items.properties') || get(changedSchema, 'properties')) {
                            if (changedSchema.type === 'array') {
                                changedSchema.type = action.changeSet.targetType;
                                changedSchema.properties = get(changedSchema, 'items.properties') || get(changedSchema, 'properties');
                                unset(changedSchema, 'items');
                            } else {
                                changedSchema.type = action.changeSet.targetType;
                                changedSchema.items = {properties: get(changedSchema, 'properties') || get(changedSchema, 'items.properties')};
                                unset(changedSchema, 'properties');
                            }
                        } else {
                            if (has(changedSchema, 'items')) {
                                unset(changedSchema, 'items');
                            } else {
                                unset(changedSchema, 'properties');
                            }
                            changedSchema.type = 'object';
                            changedSchema.properties = {};
                        }
                    }
                    break;
                case 'add-schema-ref': {
                    let changedSchema = prevState;
                    if (action.changeSet.schemaPath) {
                        changedSchema = get(prevState.responses, action.changeSet.schemaPath);
                    }
                    changedSchema[action.changeSet.operator].push({$ref: action.changeSet.link});
                    break;
                }
                case 'rm-schema-ref': {
                    let changedSchema = prevState;
                    if (action.changeSet.schemaPath) {
                        changedSchema = get(prevState.responses, action.changeSet.schemaPath);
                    }
                    if (action.changeSet.link) {
                        remove(changedSchema[action.changeSet.operator], (remoteSchema) => remoteSchema.$ref === action.changeSet.link);
                    } else {
                        changedSchema[action.changeSet.operator].splice(action.changeSet.key, 1);
                    }
                    break;
                }
                case 'set-schema-ref': {
                    let changedSchema = prevState;
                    if (action.changeSet.schemaPath) {
                        changedSchema = get(prevState.responses, action.changeSet.schemaPath);
                    }
                    changedSchema.type = action.changeSet.type;
                    if (action.changeSet.type === 'array') {
                        changedSchema.items = {$ref: action.changeSet.link};
                    } else {
                        changedSchema.$ref = action.changeSet.link;
                    }
                    break;
                }
                case 'change-combine-operator': {
                    console.log('changing response combined operator', action);
                    let changedSchema = prevState;
                    if (action.changeSet.schemaPath) {
                        changedSchema = get(prevState.responses, action.changeSet.schemaPath);
                    }
                    set(changedSchema, action.changeSet.operator, get(changedSchema, action.changeSet.old));
                    unset(changedSchema, action.changeSet.old);
                    break;
                }
                case 'add-inline-schema': {
                    let changedSchema = prevState;
                    if (action.changeSet.schemaPath) {
                        changedSchema = get(prevState.responses, action.changeSet.schemaPath);
                    }
                    changedSchema[action.changeSet.operator].push(action.changeSet.schema);
                    break;
                }
                case 'toggle-additional-properties': {
                    let changedSchema = prevState;
                    if (action.changeSet.schemaPath) {
                        changedSchema = get(prevState.responses, action.changeSet.schemaPath);
                    }
                    changedSchema.additionalProperties = action.changeSet.additionalProperties;
                    break;
                }
                default:
                    const value = get(prevState.responses, action.changeSet.propName) || {};
                    set(prevState.responses, action.changeSet.propName, merge(value, omit(action.changeSet, 'propName', 'op')));
                    break;
            }
            break;
        default:
            throw new Error('unsupported-action-type:' + action.type);
    }

    return cloneDeep(prevState);
}
